import { createContext, useContext, useState, useEffect } from "react";
import { getAppType } from "../config";

const AppTypeContext = createContext();

export const AppTypeProvider = ({ children }) => {
  const [isGic, setIsGic] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getAppType().then((type) => {
      setIsGic(type === "gic");
      setLoaded(true);
    });
  }, []);

  return (
    <AppTypeContext.Provider value={{ isGic, loaded }}>
      {children}
    </AppTypeContext.Provider>
  );
};

// 他のファイルで簡単に取得するフック
export const useAppType = () => {
  const context = useContext(AppTypeContext);
  if (!context) {
    throw new Error("useAppType must be used within an AppTypeProvider");
  }
  return context;
};
